import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getAgentsUsers, getRoles } from '@/api/agents-users';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery, formatJson } from '@/utils/index';
import { exportJson2Excel } from '@/utils/excel';
import Enabled from '@/components/Enabled/index.vue';
import Inr from '@/components/Inr/index.vue';
import router from '@/router';
import { isSuperAdmin } from '@/common';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.rolesList = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.agentId = 0;
    this.listQuery = {
      page: 1,
      limit: 10,
      id: undefined,
      fullName: undefined,
      emailAddress: undefined,
      mobileNumber: undefined,
      enabled: true,
      agentId: undefined,
      sort: 'id,DESC',
      'roles.id': undefined,
      filter: {
        emailAddress: '$contL',
        fullName: '$contL',
        mobileNumber: '$startsL',
        enabled: '$eq',
        id: '$eq',
        agentId: '$eq',
        'roles.id': '$in'
      }
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }, {
      label: ' Name A-Z',
      key: 'fullName,ASC'
    }, {
      label: 'Name Z-A',
      key: 'fullName,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
  }
  activated() {
    this.agentId = parseInt(this.$route.params && this.$route.params.agentId);
    this.listQuery = {
      ...this.listQuery,
      ...this.$route.query
    };
    // re init filter as filter gets removed when redirecting from edit pages
    if (!this.listQuery.filter) {
      this.listQuery.filter = {
        emailAddress: '$contL',
        fullName: '$contL',
        mobileNumber: '$startsL',
        enabled: '$eq',
        id: '$eq',
        agentId: '$eq',
        'roles.id': '$in'
      };
    }
    this.getAgentRoles().then(() => {
      if (!this.listQuery['roles.id'] || this.listQuery['roles.id'].length === 0) {
        delete this.listQuery['roles.id'];
      }
      this.getList();
    });
    // this.getList();
  }
  async getList() {
    try {
      this.listLoading = true;
      this.listQuery.agentId = this.agentId;
      const data = await getAgentsUsers(getQuery(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async getAgentRoles() {
    try {
      this.listLoading = true;
      this.rolesList = await getRoles(getQuery({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq'
        }
      }));
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  sortChange(data) {
    this.handleFilter();
  }
  async handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['id', 'enabled', 'Full Name', 'Mobile Number', 'Email Address', 'Is Mobile', 'Broker Name', 'Broker Mobile Number', 'Organization', 'GST Number', 'PAN Number', 'Wallet Balance', 'Wallet Usage Amount', 'Last Login', 'createdTimestamp'];
    const filterVal = ['id', 'enabled', 'fullName', 'mobileNumber', 'emailAddress', 'isMobile', 'broker.name', 'broker.mobileNumber', 'organization.name', 'organization.gstNumber', 'organization.panNumber', 'walletBalance', 'walletUsageAmount', 'pushUpdatedTimestamp', 'createdTimestamp'];
    const userFilter = Object.assign({}, this.listQuery);
    delete userFilter.limit;
    delete userFilter.page;
    const data2 = await getAgentsUsers(getQuery(userFilter));
    const data = formatJson(filterVal, data2);
    exportJson2Excel(tHeader, data, this.$tc('route.dealerManagement.ageny.title'));
    this.downloadLoading = false;
  }
  _isSuperAdmin() {
    return isSuperAdmin();
  }
  editUser(userId = 0) {
    const query = this.listQuery;
    delete query.filter;
    router.push({
      path: '/agents-users/edit/' + userId,
      query
    });
  }
};
default_1 = __decorate([Component({
  name: 'AgentsUserList',
  components: {
    Pagination,
    Enabled,
    Inr
  }
})], default_1);
export default default_1;